import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { AbstractControl,UntypedFormControl,UntypedFormGroup,NG_VALIDATORS,NG_VALUE_ACCESSOR,ValidationErrors,Validators} from "@angular/forms";
import { CompanyDetailComponent } from '../../../customer/form-part/company-detail/company-detail.component';
import {CoreService} from "../../../../services/core/core.service";
import {SharedService} from "../../shared.service";
import {pairwise, startWith} from "rxjs/operators";
import {Subscription} from "rxjs";
import { GooglePlaceDirective } from 'src/app/modules/shared/directives/google-places-autocomplete/google-places-autocomplete.directive';
import { Address } from 'src/app/modules/shared/directives/google-places-autocomplete/google-places-autocomplete.directive';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { NotOnlySpaces } from '../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import { ZipCodeValidators, CanadianPostalCodeValidator } from '../../../shared/CustomValidators/CustomZipCodeValidation';


@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AddressComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AddressComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AddressComponent implements OnInit, OnChanges {

  @Input() form?: any = '';
  @Input() model: any = {};
  @Input() isRequired: boolean = false;
//  @Input() isRequiredtrue:boolean=true;
  @Input() populateFormOnChanges: any = false;
  // Where the State dropdown panel renders. Default '' = inline (falsy, so
  // ng-select keeps the panel in place — no change for existing consumers).
  // Pass 'body' inside scroll-clipped overlays (e.g. the customer create
  // dialog) so the panel isn't cut off by overflow.
  @Input() appendTo: string = '';
  @Output() callback = new EventEmitter<any>(true);

  public randomID:number;
  public staric: string = '*';
  public onModelValueChanged: any;
  // @ts-ignore
  private parentFormSubscription: Subscription;
  public e: any;

  public addressForm: UntypedFormGroup = this.initForm();
  options = {
    types: [],
    componentRestrictions: { country: 'UA' }
  }
  constructor(
    public coreService: CoreService,
    public sharedService: SharedService,
    private http: HttpClient
  ) {
    this.randomID = this.coreService.getRandomInteger();
  }
  @ViewChild("placesRef") placesRef!: GooglePlaceDirective;
  // Must be a real object — the Google Autocomplete constructor reads properties
  // off this value. A stringified literal silently disabled the autocomplete.
  mapOptions: any = {
    fields: ['address_components', 'geometry', 'formatted_address', 'name'],
    types: ['address'],
  };

  ngOnChanges(changes: SimpleChanges) {
    if (this.populateFormOnChanges){
      this.updateFormValues(this.model);
    }
    // this.model = changes?.model?.currentValue;
  }


  ngOnInit(): void {
    this.sharedService.getStates([231,38]);
    this.updateFormValidatorOpts();
    this.updateStaricString();
    this.initSubscriptions();
    this.initFormControlValues(this.model);
    
    // Add subscription to state changes
    this.addressForm.get('state_id')?.valueChanges.subscribe(state => {
      const zipcodeControl = this.addressForm.get('zipcode');
      if (zipcodeControl) {
        zipcodeControl.setValidators(
          this.isRequired ? 
            [Validators.required, this.getZipCodeValidator()] : 
            [this.getZipCodeValidator()]
        );
        zipcodeControl.updateValueAndValidity();
      }
    });
  }



  initFormControlValues(value: any){
    if (value){
      this.addressForm = this.initForm(value);
      this.callback.emit(this.addressForm);
    }
    return this.addressForm;
  }
  omit_special_char(event: KeyboardEvent): boolean {
    const k = event.keyCode || event.which;
    // Allow numbers (0-9), backspace, space, hyphen, and parentheses
    return (k >= 48 && k <= 57) || k == 8 || k == 32 || k == 45 || k == 40 || k == 41;
  }
  initForm(value: any =''){
   return  new UntypedFormGroup({
      address_line_1:new UntypedFormControl(value ? value.address_line_1: null,this.isRequired ? [Validators.required,NotOnlySpaces()] : []),
      address_line_2:new UntypedFormControl(value ? value.address_line_2: null),
      state_id: new UntypedFormControl(value ? value.relations.state: null, this.isRequired ? [Validators.required,NotOnlySpaces()] : []),
      city:new UntypedFormControl(value ? value.city: null, this.isRequired ? [Validators.required,NotOnlySpaces()] : []),
      zipcode:new UntypedFormControl(value ? value.zipcode: null, this.isRequired ? [Validators.required, this.getZipCodeValidator()] : [this.getZipCodeValidator()]),

    });
  }
  preventSpace(event: KeyboardEvent) {
    // if (event.keyCode === 32) {
    //   event.preventDefault();
    // }
  }
  updateFormValues(value: any =''){
    this.addressForm.get('address_line_1')?.setValue(value ? value.address_line_1: null);
    this.addressForm.get('address_line_2')?.setValue(value ? value.address_line_2: null);
    this.addressForm.get('state_id')?.setValue(value ? value.relations.state: null);
    this.addressForm.get('city')?.setValue(value ? value.city: null);
    this.addressForm.get('zipcode')?.setValue(value ? value.zipcode: null);
    // this.callback.emit(this.addressForm);
  }
  updateStaricString = () => {
    if (this.isRequired) {
      this.staric = '*';
      return;
    }
    this.staric = '';
  }

  updateFormValidatorOpts = () => {
    Object.keys(this.addressForm.controls).map((controlName) => {
      if (this.isRequired) {
        if(this.addressForm.controls[controlName] != this.addressForm.controls['address_line_2']) {
          if (this.addressForm.controls[controlName] == this.addressForm.controls['zipcode']){
            this.addressForm.controls[controlName].setValidators([Validators.required, this.getZipCodeValidator()]);
          }
          else {
            this.addressForm.controls[controlName].setValidators([Validators.required,NotOnlySpaces()]);
          }
        }
      } else {
        this.addressForm.controls[controlName].clearValidators();

        if (this.addressForm.controls[controlName] == this.addressForm.controls['zipcode']){
          this.addressForm.controls[controlName].setValidators([this.getZipCodeValidator()]);
        }
      }
      this.addressForm.controls[controlName].updateValueAndValidity();
    });
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.addressForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.addressForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.addressForm.disable() : this.addressForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.addressForm.valid ? null : { invalidForm: {valid: false, message: "Address Form fields are invalid"}};
  }
  initSubscriptions(){
    console.log(this.form);
    if (this.form){
      this.parentFormSubscription = this.form.valueChanges
          .pipe(startWith(null), pairwise())
          .subscribe(([prev, next]: [any, any]) => {
            if (this.form.touched){
              this.touchFormControls();
            }
          });
    }

  }
  touchFormControls(){
    Object.keys(this.addressForm.controls).forEach(key => {
      this.addressForm.get(key)?.markAsTouched();
    });
  }


  public handleAddressChange(event: Address,formControl:any) {
    this.addressForm.reset();
    let streetNumber: string = '';
    let routeName: string = '';
    let address_line_2: string = '';
    const place = event;

    for (const component of place.address_components) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];
      // console.log('component',componentType);

      switch (componentType) {
        case "street_number": {
          streetNumber = component.long_name;
          break;
        }
        case "route": {
          routeName = component.long_name;
          break;
        }

        case "postal_code": {
          this.addressForm.get('zipcode')?.setValue(component.long_name);
          break;
        }
        case "administrative_area_level_3": {
          this.addressForm.get('city')?.setValue(component.long_name);
          break;
        }
        case "administrative_area_level_2": {
          if (!this.addressForm.get('city')?.value) {
            this.addressForm.get('city')?.setValue(component.long_name);
          }
          break;
        }
        case "locality": {
          this.addressForm.get('city')?.setValue(component.long_name);
          break;
        }
        case "administrative_area_level_1": {
          const state = this.sharedService.states.find((x:any) => x.name == component.long_name);
          console.log('state',state);
          this.addressForm.get('state_id')?.setValue(state);
          break;
        }
        case "subpremise": {
          address_line_2 = component.long_name
          this.addressForm.get('address_line_2')?.setValue(address_line_2);
          break;
        }
        //
        // case "sublocality_level_2": {
        //   address_line_2 = address_line_2 + ' ' + component.long_name
        //   this.addressForm.get('address_line_2')?.setValue(address_line_2);
        //   break;
        // }
        //
        // case "sublocality_level_1": {
        //   address_line_2 = address_line_2 + ' ' + component.long_name
        //   this.addressForm.get('address_line_2')?.setValue(address_line_2);
        //   break;
        // }
      }


    }
    // Fallback for places that don't provide formatted street split
    if (!this.addressForm.get('address_line_1')?.value) {
      const line1Fallback = `${streetNumber} ${routeName}`.trim();
      if (line1Fallback) {
        this.addressForm.get('address_line_1')?.setValue(line1Fallback);
      }
    }
    // this.getCityAndState(place?.place_id)
  }

  getCityAndState(place_id: any) {

    const apiKey = 'AIzaSyAqdhQzXSYIh-m7QT3CMypCwUoYUypvThw';
      const placeId = place_id; // The unique identifier of the place you're interested in

    const apiUrl = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&key=${apiKey}`;
    let header: any= new HttpHeaders();
    this.http.get(apiUrl,{headers:{"Access-Control-Allow-Origin": "*","Access-Control-Allow-Methods": "*",}}).subscribe((response: any) => {

        const addressComponents = response.result.address_components;
        let city, state, zipCode;

        for (const component of addressComponents) {
          if (component.types.includes('locality')) {
            city = component.long_name;
          } else if (component.types.includes('administrative_area_level_1')) {
            state = component.short_name;
          } else if (component.types.includes('postal_code')) {
            zipCode = component.short_name;
          }
        }


    });
  }

  // zip code validator
  private getZipCodeValidator() {
    const state = this.addressForm?.get('state_id')?.value;
    if (state?.country?.sortname === 'CA') {
      return CanadianPostalCodeValidator();
    }
    return ZipCodeValidators();
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.parentFormSubscription?.unsubscribe();
  }

}
